// extracted by mini-css-extract-plugin
export var container = "_5p-0";
export var disabled = "_5p-4";
export var fullWidth = "_5p-3";
export var lined = "_5p-1";
export var selected = "_5p-5";
export var tab = "_5p-2";